import { Bar, BarChart, CartesianGrid, XAxis } from "recharts"
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"
import {
    ChartConfig,
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
} from "@/components/ui/chart"
import { useEffect, useState } from "react"
import axiosInstance from "@/utils/axiosInstance"

const chartConfig = {
    orders: {
        label: "Orders",
        color: "hsl(var(--chart-1))",
    },
    totalFare: {
        label: "Fares",
        color: "hsl(var(--chart-6))",
    },
} satisfies ChartConfig

const OrdersByCommissionPartnersChart = ({ range }: { range: { startDate: Date, endDate: Date } }) => {

    const [chartData, setChartData] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axiosInstance.get('/reports/commissions', {
                    params: {
                        startDate: range.startDate.toISOString().split("T")[0],
                        endDate: range.endDate.toISOString().split("T")[0],
                    }
                })

                setChartData(res.data)
            } catch (error) {
                console.error("Gabim gjatë marrjes së të dhënave:", error)
            }
        }

        fetchData()
    }, [range])

    return (
        <Card>
            <CardHeader>
                <CardTitle>Orders by commission partners</CardTitle>
            </CardHeader>
            <CardContent>
                <ChartContainer config={chartConfig}>
                    <BarChart accessibilityLayer data={chartData}>
                        <CartesianGrid vertical={false} />
                        <XAxis
                            dataKey="commissionPartnerId"
                            tickLine={false}
                            axisLine={false}
                        />
                        <ChartTooltip
                            cursor={false}
                            content={<ChartTooltipContent indicator="dashed" />}
                        />
                        <Bar dataKey="orders" fill="var(--color-orders)" radius={4} />
                        <Bar dataKey="totalFare" fill="var(--color-chart-dark-green)" radius={4} />
                    </BarChart>
                </ChartContainer>
            </CardContent>
        </Card>
    )

}

export default OrdersByCommissionPartnersChart;